import { VatSettings } from '@shared/types';

export const getVATEnabledAndPassed = (vatSettings?: VatSettings): boolean => {
    if (vatSettings) {
        return !vatSettings.is_vat_absorbed && vatSettings.enabled ? true : false;
    }
    return false;
};
